import React, { useState, useEffect, useContext } from 'react';
import { AddToCartContext } from './AddToCartContext';
import { getStoreId, getProductPricePrefixAsync, getProductButtonColorsAsync, getProductButtonFields } from '../../../utils/StoreConfigManager';
import I18NextContext from '../i18next-context/I18NextContext';
import i18n from '../../../../i18n';

const storeId = getStoreId();
const ADD_TO_CART_COOKIE_ENUM = 'cartList';

// TODO: Add backend cart saving support, possibly by storing UUIDs + cookies
// Add To Cart Context provides modal context with access to add/remove cart functionality
// Context also used in top level UI to create a dropdown add to cart menu
const AddToCartContextComponent = (props) => {
    const [cartList, setCartList] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [cartButtonHidden, setCartButtonHidden] = useState(true);
    const [pricePrefix, setPricePrefix] = useState('$');
    const [colors, setColors] = useState();
    const [buttonFields, setButtonFields] = useState();
    const contextData = useContext(I18NextContext);
    const currentLanguage = i18n.language
   
    // TODO: Currently not tied to any functionality. To be used in dropdown cart
    // Load saved cookie if ID stored in cookie matches ID of current store
    useEffect(() => {
        (async () => {
            setPricePrefix(await getProductPricePrefixAsync());
            setColors(await getProductButtonColorsAsync());
            setButtonFields(await getProductButtonFields());
        })()
        const cartListCookie = JSON.parse(getCookie(ADD_TO_CART_COOKIE_ENUM));
        if (cartListCookie && cartListCookie['id'] === storeId) {
            const savedList = cartListCookie['cartList'];
            let cartListForJP = []
            if(currentLanguage === 'jpn_ja'){
                savedList.forEach((item)=>{
                    let obj = {SKU: item.SKU,
                        'TITLE': decodeURIComponent(item.TITLE),
                        'PRICE': item.PRICE,
                        'PRICE_PREFIX': item.PRICE_PREFIX,
                        'DOWNSIZED_THUMBNAIL': item.DOWNSIZED_THUMBNAIL,
                        'QTY': item.QTY,
                        'SIZE': item.SIZE,
                        'COLOR':item.COLOR,
                        'WIDTH': item.WIDTH,
                        'URL': decodeURIComponent(item.URL)}
                    cartListForJP.push(obj);
                })
            }
            setCartList((cartListForJP.length > 0) ? cartListForJP :savedList);
        }
    }, [])
    // Saves add to cart list in a cookie
    useEffect(() => {
        if (cartList.length > 0) {
            setCartCookie();
        }
        setItemCount(cartList.length);
    }, [cartList])

    const setCartCookie = () => {
        const today = new Date();
        const tomorrow = new Date(today);

        let cartListForJP = []
        if(currentLanguage === 'jpn_ja'){
               cartList.forEach((item,index)=>{
                let obj = {SKU: item.SKU,
                    'TITLE': encodeURIComponent('FERRAGAMO インテンス Incolore'),
                    'PRICE': item.PRICE,
                    'PRICE_PREFIX': item.PRICE_PREFIX,
                    'DOWNSIZED_THUMBNAIL': item.DOWNSIZED_THUMBNAIL,
                    'QTY': item.QTY,
                    'SIZE': item.SIZE,
                    'COLOR':item.COLOR,
                    'WIDTH': item.WIDTH,
                    'URL': encodeURIComponent(item.URL)}
                cartListForJP.push(obj);
            })
           
        }
       
        const cookieObject = {
            id: storeId,
            cartList: (cartListForJP.length > 0) ? cartListForJP  : cartList
           // cartList: cartList
        }
        const cookieString = `cartList=${JSON.stringify(cookieObject)}; expires=${tomorrow.getDate() + 1}`;
        // Sets cookie to expire a day later from latest update
        document.cookie = cookieString;
    }

    const getCookie = (name) => {
        const regEx = new RegExp(name + "=([^;]+)");
        const value = regEx.exec(document.cookie);
        return value ? currentLanguage === 'jpn_ja' ? value[1] : unescape(value[1]) : null;
    }

    const addToCart = (item) => {
        const existingCart = JSON.parse(getCookie(ADD_TO_CART_COOKIE_ENUM));
        if (existingCart) {
            var productIndex = cartList.findIndex(element => element.SKU === item.SKU);

            if(productIndex > -1){
                var updatedCartList = cartList;
                updatedCartList[productIndex].QTY += item.QTY;
                setCartList([...updatedCartList]);
            }else{
                setCartList([...cartList, item]);
            }
        }else{
            setCartList([...cartList, item]);
        }
    }

    const updateFromCart = (sku) => {
        const updatedCartList = [];
        cartList.forEach(cartItem => {
            if (cartItem.SKU !== sku) {
                updatedCartList.push(cartItem);
            } else {
                cartItem.QTY = cartItem.QTY-1;
                updatedCartList.push(cartItem);
            }
        })
        setCartList(updatedCartList);
    }

    const removeFromCart = (itemSKU) => {
        const removedList = cartList.filter(item => item.SKU !== itemSKU);
        setCartList(removedList);
    }

    const contextValue = {
        cartList,
        itemCount,
        addToCart,
        removeFromCart,
        cartButtonHidden,
        setCartButtonHidden,
        pricePrefix,
        colors,
        buttonFields,
        updateFromCart
    }

    return (
        <AddToCartContext.Provider value={contextValue}>
            {props.children}
        </AddToCartContext.Provider>
    )
}

export default AddToCartContextComponent;